import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

export function BackgroundCurve() {

    return (
        <svg style={{ width: '100%', height: '30px', backgroundColor: "#ffdd00", minHeight: "30px" }} viewBox="0 0 800 50" preserveAspectRatio="none">
          <defs></defs>
          <g>
            <g transform="matrix(1,0,0,1,0,0)">
              <clipPath id="SVGID_2_">
                <rect id="SVGID_1_" y="0" width="800" height="50" />
              </clipPath>
              <g>
                <path fill="#ffffff"  d="M0,50h800C712,18,605,8,555,8C420.2,8,133.3,22.6,0,50V0z " />
              </g>
            </g>
          </g>
       </svg>
    );
}

export function ContentCurve() {
    return (
        <svg style={{ width: '100%', height: '30px', backgroundColor:'#FFF', marginTop: "auto", minHeight: "30px" }} viewBox="0 0 800 50" preserveAspectRatio="none">
          <defs></defs>
          <g>
            <g transform="matrix(1,0,0,1,0,0)">
              <clipPath id="SVGID_2_">
                <rect id="SVGID_1_" y="0" width="800" height="50" />
              </clipPath>
              <g>
                <path fill="#ffdd00"  d="M0,50h800C712,18,605,8,555,8C420.2,8,133.3,22.6,0,50V0z " />
              </g>
            </g>
          </g>
       </svg>
    );
}

export const LogoImage = styled.img`
  height: 80px;
  width: 80px;
`;

export const InstyleButton = withStyles((theme) => ({
  root: {
    color: "var(--color-white)",
    backgroundColor: "var(--color-orange)",
    '&:hover': {
      backgroundColor: "var(--color-orange)",
    },
  },
}))(Button);

export const InstyleFloatingActionButton = withStyles((theme) => ({
  root: {
    color: "var(--color-white)",
    backgroundColor: "var(--color-orange)",
    '&:hover': {
      backgroundColor: "var(--color-orange)",
    },
    position: "absolute",
    right: "20px",
    bottom: "5px",
    width: "75px",
    height: "75px",
    borderRadius: "50%",
    boxShadow: "0 0 3px rgb(0 0 0 / 60%)",
  },
}))(Button);

export const InstyleActionButton = withStyles((theme) => ({
  root: {
    color: "var(--color-white)",
    backgroundColor: "var(--color-orange)",
    '&:hover': {
      backgroundColor: "var(--color-orange)",
    },
    width: "75px",
    height: "75px",
    borderRadius: "50%",
    boxShadow: "0 0 3px rgb(0 0 0 / 60%)",
  },
}))(Button);

export const InstyleFloatingSaveButton = withStyles((theme) => ({
  root: {
    color: "var(--color-white)",
    backgroundColor: "var(--color-orange)",
    '&:hover': {
      backgroundColor: "var(--color-orange)",
    },
    width: "100px",
    position: "absolute",
    bottom: "10%",
    right: "10%",
    boxShadow: "0 0 3px rgb(0 0 0 / 60%)",
  },
}))(Button);

export const LedBox = styled.div`
  height: 30px;
  width: 25%;
  margin: 10px 0;
  float: right;
`